/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Section_Practice_SummaryInputs */



/**
* | output |
* | --- |
* | "Time zone and language" |
*
* @param {Account_Section_Practice_SummaryInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const account_section_practice_summary = /** @type {((inputs?: Account_Section_Practice_SummaryInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Section_Practice_SummaryInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Time zone and language")
	return /** @type {LocalizedString} */ ("Fuseau horaire et langue")
});